package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.workplace.ShiftTemplateDto
import com.evoapps.evoshift.domain.model.ShiftTemplate

class ShiftTemplateMapper {

    fun toDomain(dto: ShiftTemplateDto): ShiftTemplate {
        return ShiftTemplate(
            id = dto.id,
            name = dto.name,
            startTime = dto.startTime,
            endTime = dto.endTime,
            role = dto.role,
            skills = dto.skills
        )
    }

    fun toDto(domain: ShiftTemplate): ShiftTemplateDto {
        return ShiftTemplateDto(
            id = domain.id,
            name = domain.name,
            startTime = domain.startTime,
            endTime = domain.endTime,
            role = domain.role,
            skills = domain.skills
        )
    }
}
